var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeBlackDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 24,
    viewBox: "0 0 6 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.53846 21.2308C5.53846 21.9652 5.2467 22.6696 4.72737 23.1889C4.20804 23.7082 3.50368 24 2.76923 24C2.03479 24 1.33042 23.7082 0.811089 23.1889C0.291757 22.6696 0 21.9652 0 21.2308C0 20.4963 0.291757 19.792 0.811089 19.2726C1.33042 18.7533 2.03479 18.4615 2.76923 18.4615C3.50368 18.4615 4.20804 18.7533 4.72737 19.2726C5.2467 19.792 5.53846 20.4963 5.53846 21.2308ZM5.53846 12C5.53846 12.7344 5.2467 13.4388 4.72737 13.9581C4.20804 14.4775 3.50368 14.7692 2.76923 14.7692C2.03479 14.7692 1.33042 14.4775 0.811089 13.9581C0.291757 13.4388 0 12.7344 0 12C0 11.2656 0.291757 10.5612 0.811089 10.0419C1.33042 9.52253 2.03479 9.23077 2.76923 9.23077C3.50368 9.23077 4.20804 9.52253 4.72737 10.0419C5.2467 10.5612 5.53846 11.2656 5.53846 12ZM5.53846 2.76923C5.53846 3.50368 5.2467 4.20804 4.72737 4.72737C4.20804 5.2467 3.50368 5.53846 2.76923 5.53846C2.03479 5.53846 1.33042 5.2467 0.811089 4.72737C0.291757 4.20804 0 3.50368 0 2.76923C0 2.03479 0.291757 1.33042 0.811089 0.811089C1.33042 0.291757 2.03479 0 2.76923 0C3.50368 0 4.20804 0.291757 4.72737 0.811089C5.2467 1.33042 5.53846 2.03479 5.53846 2.76923Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeBlackDots);
export default __webpack_public_path__ + "static/media/three-black-dots.858955d0d46066e1cd1aefb2535d4faf.svg";
export { ForwardRef as ReactComponent };